import React, { PureComponent, Fragment } from 'react';
import { withStyles } from '@material-ui/core/styles';
import { Dialog, DialogContent, DialogTitle } from '@material-ui/core';
import { Grid, Typography, Button, IconButton } from '@material-ui/core';
import {
  Close as CloseIcon,
  Delete as DeleteIcon,
  RemoveRedEye as ViewIcon,
} from '@material-ui/icons';
import UploadedDocument from './UploadedDocument';
import humanizeFileTypes from 'common/utilities/humanizeFileTypes';
import * as palette from 'common/shared/oldDocumentSignerUI/palette';
import Uploader from './Uploader';
import Transition from 'common/components/Transition';
import {
  MYFILES_NEXT_BTN,
  MYFILES_CANCEL_BTN,
} from 'common/components/DocumentUploader/Styles';

const styles = theme => ({
  myFilesContainer: {
    width: '92% !important',
    marginLeft: '20px',
    marginRight: '20px',
    border: '1px solid #333',
    marginBottom: '10px',
  },
  title: {
    fontFamily: 'Roboto, Helvetica Neue, Helvetica, Arial, sans-serif',
    color: '#616161',
    fontSize: '18px',
    marginBottom: '14px',
  },
  dialogContent: {
    display: 'flex',
    flexDirection: 'column',
    flexWrap: 'nowrap',
    backgroundColor: 'white',
    borderTop: '1px solid',
    borderColor: palette.white,
    padding: 0,
    marginBottom: theme.spacing.unit * 6,
    boxShadow: 'inset -1px 1px -1px rgba(0, 0, 0, 0.8)',
  },
  closeIcon: {
    top: theme.spacing.unit * 2,
    right: theme.spacing.unit * 2,
    position: 'absolute',
    cursor: 'pointer',
  },
  secondaryButton: {
    ...MYFILES_NEXT_BTN,
  },
  cancel: {
    ...MYFILES_CANCEL_BTN,
    padding: '6px 15px !important',
  },
  disabledBtn: {
    ...MYFILES_NEXT_BTN,
    opacity: '0.4',
  },
  instructions: {
    fontSize: '14px',
    color: '#616161',
    fontFamily: 'Roboto, Helvetica Neue, Helvetica, Arial, sans-serif',
  },
  modalFooter: {
    display: 'flex',
    justifyContent: 'flex-end',
    paddingRight: '30px',
    paddingBottom: '40px',
  },
  fileName: {
    color: '#212121',
    fontFamily: 'Roboto, Helvetica Neue, Helvetica, Arial, sans-serif',
    fontSize: 14,
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap',
    padding: 12,
  },
  deleteIcon: {
    cursor: 'pointer',
    color: '#9e9e9e',
  },
  eyeIcon: {
    color: '#2eaba4',
    height: '16px',
    width: '16px',
    position: 'relative',
    bottom: '7px',
    '&:hover': {
      color: '#ffffff',
    },
  },
  eyeIconCircle: {
    width: 24,
    height: 24,
    backgroundColor: '#f5f5f5',
    '&:hover': {
      backgroundColor: '#2eaba4',
    },
  },
  rowContainer: {
    minHeight: 24,
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-between',
  },
  viewCopy: {
    fontFamily: 'Roboto, Helvetica, Helvetica Neue, san-serif',
    fontSize: '10px',
    color: '#9e9e9e',
  },
});

class SupportingDocumentUploaderModal extends PureComponent {
  state = {
    files: [],
    isDocumentModalOpen: this.props.open,
    selectedMyFiles: [],
  };

  componentWillReceiveProps(nextProps) {
    const {
      uploadedSupportDocuments = [],
      recentlySelectedMyFiles = [],
    } = nextProps;
    if (
      recentlySelectedMyFiles.length > 0 &&
      uploadedSupportDocuments.length > 0
    ) {
      const myFiles = recentlySelectedMyFiles.reduce(
        (arr, file) =>
          arr.concat(
            uploadedSupportDocuments.filter(({ name }) => name === file.name),
          ),
        [],
      );
      this.setState({ selectedMyFiles: myFiles });
    }
  }

  getDefaultInstructions = () => {
    const { fileTypes = '' } = this.props;
    const hFileTypes = humanizeFileTypes(fileTypes);
    return `Please upload ${hFileTypes} files only, other types of files will not
      be accepted.`;
  };

  handleClose = () => {
    const { closeModalHandler } = this.props;
    closeModalHandler();
  };

  handleUpload = files => {
    const { maxFiles } = this.props;
    const { files: currentFiles } = this.state;
    let filesToProcess;
    // This set of conditionals are to forbid the upload of more files
    // than allowed
    if (currentFiles.length === maxFiles) return;
    if (maxFiles && files.length + currentFiles.length >= maxFiles) {
      const maxAllowed = maxFiles - currentFiles.length;
      filesToProcess = files.slice(0, maxAllowed);
    } else {
      filesToProcess = files;
    }
    const fs = filesToProcess.map(f => ({
      fileId: null,
      file: f,
      fileName: f.name,
    }));
    this.setState({
      files: [...this.state.files, ...fs],
    });
  };

  getDeleteHandler = file => {
    const { deleteHandler: upstreamDeleteHandler } = this.props;
    if (!upstreamDeleteHandler) return;
    return ({ fileId }) =>
      upstreamDeleteHandler({ fileId }).then(() =>
        this.setState(({ files }) => ({
          files: files.filter(f => f.file !== file),
        })),
      );
  };

  deleteMyFile = file => {
    const { deleteHandler } = this.props;
    const uploadedFile = {
      ...file,
      fileId: file.id,
    };
    deleteHandler(uploadedFile).then(() =>
      this.setState(({ selectedMyFiles }) => ({
        selectedMyFiles:
          selectedMyFiles.length > 0
            ? selectedMyFiles.filter(f => f !== file)
            : selectedMyFiles,
      })),
    );
  };

  selectFromMyFiles = () => {
    const { closeModalHandler, myFilesModalHandler } = this.props;
    closeModalHandler();
    myFilesModalHandler();
  };

  handleNext = () => {
    const { closeModalHandler, successModalHandler } = this.props;
    const { files } = this.state;
    closeModalHandler();
    successModalHandler(files);
  };

  cancelEverything = () => {
    const {
      closeModalHandler,
      deleteHandler,
      uploadedSupportDocuments,
    } = this.props;
    const { selectedMyFiles, files } = this.state;
    // delete normal uploaded files
    let uploadedFromComputer = [];
    files.forEach(item => {
      let temp = uploadedSupportDocuments.filter(
        arrItem => arrItem.name === item.fileName,
      );
      uploadedFromComputer.push(...temp);
    });

    if (selectedMyFiles.length > 0) {
      selectedMyFiles.forEach(({ id, canDelete }) =>
        canDelete ? deleteHandler({ fileId: id }) : null,
      );
    }
    if (uploadedFromComputer.length > 0) {
      uploadedFromComputer.forEach(({ id, canDelete }) =>
        canDelete ? deleteHandler({ fileId: id }) : null,
      );
    }
    closeModalHandler();
  };

  render() {
    const {
      title,
      instructions = this.getDefaultInstructions(),
      classes,
      editableFiles,
      uploadHandler,
      editHandler,
      fileTypes,
      viewHandler,
    } = this.props;
    const { isDocumentModalOpen, files, selectedMyFiles } = this.state;

    const optionalProps = viewHandler ? { viewHandler } : {};

    const filesDiv = files.map(f => (
      <UploadedDocument
        key={`${f.fileName}-${f.file.size}`}
        document={f}
        editable={editableFiles}
        editHandler={editHandler}
        uploadHandler={uploadHandler}
        deleteHandler={this.getDeleteHandler(f.file)}
        closeModalHandler={this.handleClose}
        {...optionalProps}
      />
    ));

    const myFilesDiv = selectedMyFiles.map(f => (
      <div className={classes.myFilesContainer}>
        <Grid container>
          <Grid item xs={9}>
            <p className={classes.fileName}>{f.name}</p>
          </Grid>
          <Grid item xs={1}>
            <IconButton onClick={() => viewHandler(f.id)}>
              <ViewIcon data-test-id="DocumentUploaderModal-Document-view" />
            </IconButton>
          </Grid>
          <Grid item xs={1}>
            <IconButton onClick={() => this.deleteMyFile(f)}>
              <DeleteIcon />
            </IconButton>
          </Grid>
        </Grid>
      </div>
    ));

    const showNextBtn = !!files;
    const showAddDocumentBtn = selectedMyFiles.length > 0 && files.length === 0;
    const isNextBtnDisabled = files.length === 0;
    return (
      <Fragment>
        <Dialog
          open={isDocumentModalOpen}
          onClose={this.handleClose}
          aria-labelledby="responsive-dialog-title"
          TransitionComponent={Transition}
          classes={{
            root: classes.root,
          }}
          style={{ zIndex: 200 }}
        >
          <DialogTitle id="responsive-dialog-title" disableTypography>
            <Typography
              variant="h6"
              className={classes.title}
              data-test-id="SupportingDocumentUploaderModal-title"
            >
              {title}
            </Typography>
            <Typography variant="caption" className={classes.instructions}>
              {instructions} You can upload multiple files at a time.
            </Typography>
            <div className={classes.closeIcon}>
              <CloseIcon
                onClick={this.handleClose}
                data-test-id="DocumentUploaderModal-close"
              />
            </div>
          </DialogTitle>

          <DialogContent className={classes.dialogContent}>
            {myFilesDiv}
            {filesDiv}
            <Uploader
              onUpload={this.handleUpload}
              accept={fileTypes}
              handleMyFiles={this.selectFromMyFiles}
            />
          </DialogContent>
          <div className={classes.modalFooter}>
            <Button
              size="medium"
              variant="text"
              className={classes.cancel}
              onClick={this.cancelEverything}
            >
              Cancel
            </Button>
            {showNextBtn && !showAddDocumentBtn && (
              <Button
                size="medium"
                variant="contained"
                className={
                  isNextBtnDisabled
                    ? classes.disabledBtn
                    : classes.secondaryButton
                }
                data-test-id="SupportingDocumentUploaderModal-next"
                onClick={() => this.handleNext()}
                disabled={isNextBtnDisabled}
              >
                Next
              </Button>
            )}
            {showAddDocumentBtn && (
              <Button
                size="medium"
                variant="contained"
                className={classes.secondaryButton}
                data-test-id="documentuploader-add-document-button"
                onClick={this.handleClose}
              >
                Add Document
              </Button>
            )}
          </div>
        </Dialog>
      </Fragment>
    );
  }
}

SupportingDocumentUploaderModal.defaultProps = {
  editableFiles: false,
  minFiles: 1,
  title: 'Upload Documents',
};

export default withStyles(styles)(SupportingDocumentUploaderModal);
